// Recovered compiled webpack factory 10836. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    Object.defineProperty(t, "findHeadInCache", {
      enumerable: !0,
      get: function () {
        return o;
      },
    }));
  let n = r(65360),
    a = r(69190);
  function o(e, t) {
    return (function e(t, r, o, i) {
      if (0 === Object.keys(r).length) return [t, o, i];
      let s = Object.keys(r).filter((e) => "children" !== e);
      for (let i of ("children" in r && s.unshift("children"), s)) {
        let [s, l] = r[i];
        if (s === n.DEFAULT_SEGMENT_KEY) continue;
        let u = t.parallelRoutes.get(i);
        if (!u) continue;
        let c = (0, a.createRouterCacheKey)(s),
          f = (0, a.createRouterCacheKey)(s, !0),
          d = u.get(c);
        if (!d) continue;
        let p = e(d, l, o + "/" + c, o + "/" + f);
        if (p) return p;
      }
      return null;
    })(e, t, "", "");
  }
  ("function" == typeof t.default || ("object" == typeof t.default && null !== t.default)) &&
    void 0 === t.default.__esModule &&
    (Object.defineProperty(t.default, "__esModule", { value: !0 }),
    Object.assign(t.default, t),
    (e.exports = t.default));
}
